<template>
  <ContactReviewDisplayComponent
    :accountData="accountData"
    :companyIndex="companyIndex"
    :editableAccountFields="accountFields"
    :editableCompanyFields="companyFields"
    :enableCompanySearch="true"
    :countryCode="countryCode"
    @updateAccountData="$emit('updateAccountData', $event)"
    @handleUpdateCompany="$emit('handleUpdateCompany', $event)"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import type { Account, Company, ContactFieldType } from "@/types";
import { useContactReviewValidation } from "@/composables/useContactReviewValidation";
import { useI18n } from "vue-i18n";
import ContactReviewDisplayComponent from "@/signup/ContactReviewDisplayComponent.vue";
import { useSignupStore } from "@/signup/signup";

defineProps<{
  accountData: Account;
  companyIndex?: number;
}>();

defineEmits<{
  updateAccountData: [accountData: Account];
  handleUpdateCompany: [company: Company];
}>();

const { t } = useI18n();
const { accountRules, companyRules } = useContactReviewValidation(t);
const { country: countryCode } = storeToRefs(useSignupStore());

const accountFields: ContactFieldType[] = [
  {
    label: t("account.name"),
    id: "account-name",
    model: "name",
    type: "text",
    editable: true,
    validators: accountRules.name,
  },
  {
    label: t("account.phone_number"),
    id: "account-phone-number",
    model: "phone_number",
    type: "tel",
    editable: true,
    validators: accountRules.phone_number,
  },
];

const companyFields: ContactFieldType[] = [
  {
    label: t("company.name"),
    id: "company-name",
    model: "name",
    type: "text",
    editable: true,
    validators: companyRules.name,
  },
  {
    label: t("company.registry_code"),
    id: "company-registry-code",
    model: "registry_code",
    type: "text",
    editable: true,
    validators: companyRules.registry_code,
  },
  {
    label: t("company.address"),
    id: "company-address",
    model: "address",
    type: "text",
    editable: true,
    validators: companyRules.address,
  },
  {
    label: t("company.vat"),
    id: "company-vat",
    model: "vat",
    type: "text",
    editable: true,
    validators: companyRules.vat,
  },
];
</script>
